import { Container } from "@mui/material"
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next';
import SEO from './SEO';

const Eventos = () => {
    const { t } = useTranslation();
    return (<>
    <SEO
      titleKey="seo.eventsTitle"
      descriptionKey="seo.eventsDescription"
      path="/events"
    />
    <section className="banner dark" >
    <div id="menu-parallax">
      <div className="bcg background41"
                data-center="background-position: 50% 0px;"
                data-anchor-target="#menu-parallax"
              >
        <div className="bg-transparent">
          <div className="banner-content">
            <div className="container" >
              <div className="slider-content  " style={{paddingTop:'160.5px'}}>
                <h1>{t('events.title')}</h1>
                <p>{t('events.subtitle')}</p>
                <ol className="breadcrumb">
                  <li><Link to='/'>{t('nav.home')}</Link></li>
                  <li>{t('events.breadcrumb')}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="padding-b-40 padding-t-40 menu_today">
  <div className="container">
    <div className=" texte-center chef-style-2">
  <h3 className="text-center">{t('events.mainTitle')}</h3>
  <p>
  {t('events.mainDescription')}
  </p></div>
  <div className="menu_today dark padding-b-20">
        <div className="row">
          <div className="menu-item col-md-4 col-sm-4 col-xs-12">
            <figure> <img className="img-responsive" src="img/eventos/casamentos.png" alt={t('events.weddings')} />
              <figcaption className="text-center">
                <div className="fig_container">
                  <h3>{t('events.weddings')}</h3>
                  <p>{t('events.weddingsDesc')}</p>
                </div>
              </figcaption>
            </figure>
          </div>
          <div className="menu-item col-md-4 col-sm-4 col-xs-12">
            <figure> <img className="img-responsive" src="img/eventos/batizados.png" alt={t('events.baptisms')} />
              <figcaption className="text-center">
                <div className="fig_container">
                  <h3>{t('events.baptisms')}</h3>
                  <p>{t('events.baptismsDesc')}</p>
                </div>
              </figcaption>
            </figure>
          </div>
          <div className="menu-item col-md-4 col-sm-4 col-xs-12">
            <figure> <img className="img-responsive" src="img/eventos/eventos.png" alt={t('events.customEvents')} />
              <figcaption className="text-center">
                <div className="fig_container">
                  <h3>{t('events.customEvents')}</h3>
                  <p>{t('events.customEventsDesc')}</p>
                </div>
              </figcaption>
            </figure>
          </div>
        </div>
        </div>
      </div>
  </section>
    
    </>)
}

export default Eventos